import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';
import { Typography } from '@mui/material';
import Container from 'components/Container';
import ScienceClubSideBar from '../ScienceClubSideBar';
import Sidebar2026 from '../ScienceClub/Sidebar2026';
import { EvsCca } from '..';

const EVSCCAClass12026 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });

    const [config, setConfig] = useState({ base_image_url_2026: '' });
    useEffect(() => {
        fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
            .then(response => response.json())
            .then(data => setConfig(data))
            .catch(error => console.error('Error fetching config:', error));
    }, []);

    const p1 = `${config.base_image_url_2026}/home/events-activities/association/ScienceClub/EVSclass1/1.webp`;
    const p2 = `${config.base_image_url_2026}/home/events-activities/association/ScienceClub/EVSclass1/2.webp`;
    const p3 = `${config.base_image_url_2026}/home/events-activities/association/ScienceClub/EVSclass1/3.webp`;
    const p4 = `${config.base_image_url_2026}/home/events-activities/association/ScienceClub/EVSclass1/4.webp`;
    const p5 = `${config.base_image_url_2026}/home/events-activities/association/ScienceClub/EVSclass1/5.webp`;
    const p6 = `${config.base_image_url_2026}/home/events-activities/association/ScienceClub/EVSclass1/6.webp`;
    const p7 = `${config.base_image_url_2026}/home/events-activities/association/ScienceClub/EVSclass1/7.webp`;
    const p8 = `${config.base_image_url_2026}/home/events-activities/association/ScienceClub/EVSclass1/8.webp`;
    const p9 = `${config.base_image_url_2026}/home/events-activities/association/ScienceClub/EVSclass1/9.webp`;
    const p10 = `${config.base_image_url_2026}/home/events-activities/association/ScienceClub/EVSclass1/10.webp`;
    const p11 = `${config.base_image_url_2026}/home/events-activities/association/ScienceClub/EVSclass1/11.webp`;
    const p12 = `${config.base_image_url_2026}/home/events-activities/association/ScienceClub/EVSclass1/12.webp`;

    const photos = [
        {
            src: p1,
            source: p1,
            rows: 1.5,
            cols: 1,
        },
        {
            src: p2,
            source: p2,
            rows: 1.5,
            cols: 1,
        },
        {
            src: p3,
            source: p3,
            rows: 1.5,
            cols: 1,
        },
        {
            src: p4,
            source: p4,
            rows: 1.5,
            cols: 1,
        },
         {
            src: p5,
            source: p5,
            rows: 1.5,
            cols: 1,
        },
        {
            src: p6,
            source: p6,
            rows: 1.5,
            cols: 1,
        },
        {
            src: p7,
            source: p7,
            rows: 1.5,
            cols: 1,
        },
         {
            src: p8,
            source: p8,
            rows: 1.5,
            cols: 1,
        },
         {
            src: p9,
            source: p9,
            rows: 1.5,
            cols: 1,
        },
         {
            src: p10,
            source: p10,
            rows: 1.5,
            cols: 1,
        },
         {
            src: p11,
            source: p11,
            rows: 1.5,
            cols: 1,
        },
         {
            src: p12,
            source: p12,
            rows: 1.5,
            cols: 1,
        },

       
    ];

    return (
        <Main>

            <Container>

                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box paddingX={{ xs: 0, sm: 4, md: 6 }}>
                                <Typography variant='h5' align='center' >
                                    Topic: My Favourite Season
                                </Typography>
                                <br />
                                <Typography
                                    fontSize="x-small"
                                > <br />
                                    Classes: 1  Date: 24th July 2026
                                </Typography>

                                <br />
                                <Typography variant={'subtitle1'} align={'justify'}>
The students of Class 1 enthusiastically participated in the EVS Inter-House CCA Competition held on Friday,
24 July 2026. The theme of the competition was <strong>‘My Favourite Season’,</strong> encouraging students to appreciate
the beauty and uniqueness of the different seasons while developing their communication and presentation
skills.                               <br/>
In the preliminary round of the Seasons Presentation, Class 1 students confidently spoke a few lines about
their favourite season. This activity helped enhance their confidence, speaking skills and knowledge of the
various seasons.
                                <br />
                                The final round, held on 24 July 2026, witnessed the finalists dressed creatively to represent different seasons.
They confidently spoke a few lines about the season they portrayed, showcasing their enthusiasm and
creativity. The activity provided a wonderful platform for students to express themselves, build confidence,
enhance their communication skills and deepen their understanding of the different seasons in a fun,
engaging and interactive manner.
                                 <br />
                                </Typography>
                            </Box>
                            <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                 "Little Voices, Colourful Seasons, Big Confidence!”
                                <br />
                            </Typography>

                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 200 : 100}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>

                        <Box marginBottom={4}>
                            <Sidebar2026 />
                        </Box>
                        <Box marginBottom={4}>
                            <ScienceClubSideBar />
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </Main>
    );
};

export default EVSCCAClass12026;